import {Component} from '@angular/core';
import {BrandImageDirective} from 'src/app/shared/directives/brand-image.directive';
import {RouterLink} from '@angular/router';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    imports: [
        BrandImageDirective,
        RouterLink,
    ]
})
export class PageNotFoundComponent {

  constructor() { }

}
